import {AbstractControl, FormGroup} from '@angular/forms';
import {UserService} from '../services/user/user.service';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs';

export class ValidateUserNameNotTaken {
  static validate(userService: UserService, allowedNames: string[]) {
    return (control: AbstractControl) => {
      return userService.getByUsername(control.value).pipe(
        map(user => user && allowedNames.indexOf(user.userName) === -1 ? { userNameTaken: true } : null),
        catchError(() => of(null))
      );
    };
  }
}
